import React ,{useState}  from 'react'
import { Formik } from 'formik';
import { Container,Dimmer,Loader,Form,Grid,Button,Card} from 'semantic-ui-react';
import * as Yup from "yup";
import APIService from '../../Services/API/APIService';
import { toast } from "react-toastify";

const Profile = () => {
  const [user] = useState(APIService.fetchUser())
const [loading,setLoading] = useState(false)
const schema = Yup.object().shape({
  firstname: Yup.string().required("Required"),
  lastname: Yup.string().required("Required"),
  phoneNumber:  Yup.number().required('Required').test('len', 'Must be exactly 11 characters', val => !val || (val && val.toString().length === 10)),
});


const newItem = {
  firstname:  user?.firstname ,
  lastname:  user?.lastname ,
  phoneNumber: user?.phone,

};

const _updateCustomer = async (customer) => {
  try {
    setLoading(true);
    let response = await APIService.postData(
      "/guest-house/updateCustomer",
      customer
    );

    if (response.success) {
       toast.success('Update Successful')
       APIService.signOut()
  
    } else {
      toast.error('Update Failed');
    }

    setLoading(false);
  } catch (error) {
    console.log("error", error);
    setLoading(false);
  }
};

  return (
    <Container fluid>

    {loading && (
      <Dimmer active inverted>
        <Loader> Update ..... </Loader>
      </Dimmer>
    )}


    <Grid centered >


      <Grid.Row>
        <Card centered style={{ width: "50%" }}>
       
          <Card.Content textAlign="left">
            <Formik
              enableReinitialize={true}
              initialValues={newItem}
              validationSchema={schema}
              onSubmit={(values, { resetForm }) => {
                _updateCustomer(values);
                resetForm();
              }}
            >
              {(props) => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleSubmit,
                } = props;
                return (
                  <Form onSubmit={handleSubmit} loading={loading}>
               
                    <Form.Group widths={2}>
                      <Form.Input
            
                        placeholder="First Name"
                        name="firstname"
                        value={values.firstname}
                        onChange={handleChange}
                        error={touched.firstname && errors.firstname}
                      />
                    
                    </Form.Group>

                    <Form.Group  widths={2} >
                    
                      <Form.Input
                    
                        placeholder="Last Name"
                        name="lastname"
                        value={values.lastname}
                        onChange={handleChange}
                        error={touched.lastname && errors.lastname}
                      />
                 
                    </Form.Group>
                    <Form.Group widths={2} >

                      <Form.Input

                 
                        placeholder="Customer Phone"
                        name="phoneNumber"
                        value={values.phoneNumber}
                        onChange={handleChange}
                        type={'phone'}
                        error={touched.phoneNumber && errors.phoneNumber}
                      />

                    </Form.Group>


                    <div style={{ textAlign: "center", marginTop: 30 }}>
                      <Button

                        style={{ backgroundColor: '#26f09e', color: '#000000', width: '30em' }}
                        content="Update"
                        type="submit"
                      />
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Card.Content>

        </Card>
      </Grid.Row>
    </Grid>

  </Container>
  )
}

export default Profile